module.exports = __webpack_public_path__ + "static/media/about-img.5ec2eafc.webp";